import { ChangePasswordForm } from '@/components/auth/ChangePasswordForm';
import { useAuth } from '@/services/auth';
import { tokenManager } from '@/services/auth/tokenManager';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, requiresPasswordChange } = useAuth();
  const passwordChangeFlow = tokenManager.getPasswordChangeFlow();
  const redirectPath = passwordChangeFlow?.redirectPath ?? null;
  const hasPasswordChangeSession = requiresPasswordChange || passwordChangeFlow !== null;

  useEffect(() => {
    if (hasPasswordChangeSession) {
      return;
    }

    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
      return;
    }

    navigate('/login', { replace: true });
  }, [hasPasswordChangeSession, isAuthenticated, navigate]);

  const handleSuccess = () => {
    if (!redirectPath) {
      navigate('/dashboard', { replace: true });
      return;
    }

    navigate(redirectPath, { replace: true });
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5">
                <div className="text-center mb-4">
                  <h1 className="h3 mb-3 fw-bold">Change Your Password</h1>
                  <p className="text-muted mb-0">
                    Your account requires a password update before continuing.
                  </p>
                </div>

                <ChangePasswordForm onSuccess={handleSuccess} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
